import { UPDATE_COMS_CONFIG, UPDATE_COMS_CONFIG_SUCCESS, UPDATE_COMS_CONFIG_ERROR, UPDATE_COMS_CONFIG_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateComsConfig = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_COMS_CONFIG:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_COMS_CONFIG_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case UPDATE_COMS_CONFIG_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_COMS_CONFIG_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateComsConfig;
